import type { ColumnSchema } from '@/components/crud/types';

export const liveEditorColumns: ColumnSchema[] = [
  { type: 'custom', prop: 'date', label: '投诉日期', width: 132, slotName: 'col-date', align: 'center' },
  { type: 'custom', prop: 'yc', label: '异常投诉', minWidth: 140, slotName: 'col-yc' },
  { type: 'custom', prop: 'deptP', label: '生产部门', width: 112, slotName: 'col-deptP' },
  { type: 'custom', prop: 'fzr', label: '负责人', width: 168, slotName: 'col-fzr' },
  { type: 'custom', prop: 'cause', label: '原因', minWidth: 120, slotName: 'col-cause' },
  { type: 'custom', prop: 'temp', label: '临时对策', minWidth: 120, slotName: 'col-temp' },
  { type: 'custom', prop: 'permanent', label: '永久对策', minWidth: 120, slotName: 'col-permanent' },
  { type: 'custom', prop: 'replyActual', label: '回复', width: 132, slotName: 'col-reply', align: 'center' },
  { type: 'custom', prop: 'defectActual', label: '不良品', width: 132, slotName: 'col-defect', align: 'center' },
  { type: 'custom', prop: 'closeActual', label: '结案', width: 132, slotName: 'col-close', align: 'center' },
];
